import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "rounded-md bg-yellow-400/80 p-4 text-center text-xs sm:text-sm text-gray-50 flex-1 m-5" }
const _hoisted_3 = {
  key: 1,
  class: "vjs-loading-spinner"
}
const _hoisted_4 = ["title"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "vjs-icon-placeholder",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "vjs-control-text",
  "aria-live": "polite"
}, "Fullscreen", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

import screenfull from "screenfull";
import { computed, onMounted, onUnmounted, PropType, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useMostRecentCameraImageUrl } from "shared/composables/camera";
import {
  useFullScreen4to3RatioDimensionStyle,
  useFullWindow4to3RatioDimensionStyle,
} from "@/composables/screen";


export default /*#__PURE__*/_defineComponent({
  __name: 'LiveConnectionLost',
  props: {
  cameraId: {
    type: String,
    required: true,
  },
  showControls: {
    type: Boolean,
    required: false,
    default: true,
  },
  noSrcMessage: {
    type: String as PropType<string | null>,
    required: false,
    default: "",
  },
},
  setup(__props) {

const loading = ref(false);
const isUserActive = ref(true);
const isFullScreen = ref(false);
const isFakeFullScreen = ref(false);
const containerRef = ref<HTMLDivElement | null>(null);
const userActiveInitialTimer = ref<ReturnType<typeof setTimeout> | null>(null);

const fullScreen4to3RatioDimensionStyle = useFullScreen4to3RatioDimensionStyle();
const fullWindow4to3RatioDimensionStyle = useFullWindow4to3RatioDimensionStyle();
const { t } = useI18n();

const props = __props;

const camera = computed(() => props.cameraId);
const { mostRecentCameraImageUrl } = useMostRecentCameraImageUrl(camera);

const noSrcMessageText = computed(() => {
  return props.noSrcMessage ? props.noSrcMessage : t("video_player.unable_to_play_message");
});
const full4to3RatioDimensionStyle = computed(() => {
  if (isFakeFullScreen.value) {
    return fullWindow4to3RatioDimensionStyle.value;
  }
  if (isFullScreen.value) {
    return fullScreen4to3RatioDimensionStyle.value;
  }
  return "";
});

const handleImageClick = () => {
  if (!props.showControls) {
    return;
  }
};

const handleFullScreenClick = () => {
  if (!screenfull.isEnabled) {
    isFakeFullScreen.value = !isFakeFullScreen.value;
    return;
  }
  if (screenfull.isFullscreen) {
    screenfull.exit();
  } else if (containerRef.value) {
    screenfull.request(containerRef.value, { navigationUI: "hide" });
  }
};

const handleFullscreenChange = () => {
  isFullScreen.value = screenfull.isFullscreen;
};

const stopUserActiveInitialTimer = () => {
  if (userActiveInitialTimer.value !== null) {
    clearTimeout(userActiveInitialTimer.value);
  }
};

const hideImage = ref(false);

onMounted(() => {
  if (screenfull.isEnabled) {
    screenfull.on("change", handleFullscreenChange);
  }
});

onUnmounted(() => {
  if (screenfull.isEnabled) {
    screenfull.off("change", handleFullscreenChange);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(isFakeFullScreen.value ? 'fixed inset-0 bg-oaiGray-900' : ''),
    onClick: _cache[6] || (_cache[6] = ($event: any) => (isFakeFullScreen.value = false)),
    style: _normalizeStyle(isFakeFullScreen.value ? 'z-index: 2147483004' : '')
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["bg-oaiGray-900 video-js vjs-live vjs-4-3", {
        'vjs-waiting': loading.value,
        'vjs-user-active': isUserActive.value,
        'vjs-user-inactive': !isUserActive.value,
        'vjs-has-started': _unref(mostRecentCameraImageUrl),
        'vjs-fullscreen': isFullScreen.value || isFakeFullScreen.value,
        'vjs-controls-enabled': __props.showControls,
      }]),
      onMouseenter: _cache[3] || (_cache[3] = ($event: any) => {
        stopUserActiveInitialTimer();
        isUserActive.value = true;
      }),
      onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (isUserActive.value = false)),
      onMousemove: _cache[5] || (_cache[5] = ($event: any) => (isUserActive.value = true)),
      ref_key: "containerRef",
      ref: containerRef
    }, [
      _createElementVNode("div", {
        class: "image-content select-none",
        style: _normalizeStyle(full4to3RatioDimensionStyle.value)
      }, [
        (!hideImage.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _unref(mostRecentCameraImageUrl),
              alt: "live image",
              class: "h-full",
              onClick: [
                handleImageClick,
                _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              ],
              onDblclick: handleFullScreenClick,
              onError: _cache[1] || (_cache[1] = ($event: any) => (hideImage.value = true))
            }, null, 40, _hoisted_1))
          : _createCommentVNode("", true)
      ], 4),
      (!isFakeFullScreen.value && !isFullScreen.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "error-content",
            style: _normalizeStyle(`${full4to3RatioDimensionStyle.value}; height: auto;`)
          }, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(noSrcMessageText.value), 1)
          ], 4))
        : _createCommentVNode("", true),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true),
      (__props.showControls && !hideImage.value && isUserActive.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "vjs-control-bar pr-5 flex justify-end",
            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("button", {
              class: "vjs-fullscreen-control vjs-control vjs-button",
              type: "button",
              title: isFullScreen.value ? 'Non-Fullscreen' : 'Fullscreen',
              "aria-disabled": "false",
              onClick: handleFullScreenClick
            }, _hoisted_7, 8, _hoisted_4)
          ]))
        : _createCommentVNode("", true)
    ], 34)
  ], 6))
}
}

})